import {ChangeDetectionStrategy, Component, Output, EventEmitter} from '@angular/core';
import {Boolean, Text, Hidden} from '@atlas/businesstypes';
import {
  FileUploaderController,
  FileUploaderSlideInConfig,
  Reference,
} from '@hermes/file-uploader';
//import {MessagingService} from '@hermes/messaging';
import { ClaimsUploadResponse } from '../../../model/claims/ClaimsUploadResponse';
import { TALON_ACTION } from '../../../constant/config/config';
import { ApiService } from '../../../backend/api.service';


const constraintText = 'Only (doc|docx|xls|xlsx|pdf|txt|jpg|jpeg|png|svg|gif). max. 10MB';
const uploadFileTitle = 'Upload Photos';
const uploadDocTitle = 'Upload Documents';


@Component({
  selector: 'systemcode-claims-file-uploader',
  templateUrl: './claims-file-uploader.component.html',
  styleUrls: ['./claims-file-uploader.component.css'],
  providers: [FileUploaderController],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClaimsFileUploaderComponent{

  public fileUploaderSelector = {disabled: new Boolean(false)};
  public filesToUpload = 5;
  public uploadedFiles: Reference[] = [];
  public uploadedFilesBasic: Reference[] = [];
  public uploadedFilesLimitless: Reference[] = [];
  public docments: string = TALON_ACTION.CLAIM_DOCUMENT;
  public photos: string = TALON_ACTION.CLAIM_PHOTOS;

  public slideInConfig_doc: FileUploaderSlideInConfig = {
    title: new Text(uploadFileTitle),
    maxNumberOfFiles: 5,
    mimeTypes:  new RegExp('/|^text\/|^image\/|^application\/pdf|^application\/msword|^application\/vnd.openxmlformats-officedocument.wordprocessingml.document|^application\/msexcel|^application/vnd.openxmlformats-officedocument.spreadsheetml.sheet$/'),
    maxTotalFileSize: 10000000, // byte to 10mb
    dropZones: [
      {
        constraintText,
      },
    ],
    afterDownload: (reference: Reference) => {
      console.log('on download', this.slideInConfig.title, reference);
    },
    afterUpload: (references: Reference[]) => {
      console.log('on upload', this.slideInConfig.title, references);
      if(references && references.length>0){
        const idRef: Hidden = references[0].id;
        const nameRef: Text = references[0].name;
        const typeRef: Text = references[0].type;
        const cascoUploadResponse : ClaimsUploadResponse = {
          action: TALON_ACTION.UPLOAD,
          imageSide: this.photos,
          id: idRef['encryptedValue'],
          name: nameRef['internalValue'],
          type: typeRef['internalValue'],
        }
        this.emitUploadedFile.emit(cascoUploadResponse);
      }else{
        this.addErrorMessageIn5Seconds();
      }
    },
    afterDelete: (reference: Reference) => {
      console.log('on delete', this.slideInConfig.title, reference);

      if(reference){
        const idRef: Hidden = reference.id;
        const nameRef: Text = reference.name;
        const typeRef: Text = reference.type;
        const cascoUploadResponse : ClaimsUploadResponse = {
          action: TALON_ACTION.DELETE,
          imageSide: this.photos,
          id: idRef['encryptedValue'],
          name: nameRef['internalValue'],
          type: typeRef['internalValue'],
        }
        this.emitUploadedFile.emit(cascoUploadResponse);
      }

    },
  };

  public slideInConfig: FileUploaderSlideInConfig = {
    title: new Text(uploadDocTitle),
    maxNumberOfFiles: 5 ,
    maxTotalFileSize: 10000000, // byte to 10mb
    dropZones: [
      {
        constraintText: new Text('Only PNG or JPEG max. 10MB'),
      },
    ],
    afterDownload: (reference: Reference) => {
      console.log('on download', this.slideInConfig_doc.title, reference);
    },
    afterUpload: (references: Reference[]) => {
      console.log('on upload', this.slideInConfig_doc.title, references);
      if(references && references.length>0){
        const idRef: Hidden = references[0].id;
        const nameRef: Text = references[0].name;
        const typeRef: Text = references[0].type;
        const cascoUploadResponse : ClaimsUploadResponse = {
          action: TALON_ACTION.UPLOAD,
          imageSide: this.docments,
          id: idRef['encryptedValue'],
          name: nameRef['internalValue'],
          type: typeRef['internalValue'],
        }
        this.emitUploadedFile.emit(cascoUploadResponse);
      }else{
        this.addErrorMessageIn5Seconds();
      }
    },
    afterDelete: (reference: Reference) => {
      console.log('on delete', this.slideInConfig_doc.title, reference);

      if(reference){
        const idRef: Hidden = reference.id;
        const nameRef: Text = reference.name;
        const typeRef: Text = reference.type;
        const cascoUploadResponse : ClaimsUploadResponse = {
          action: TALON_ACTION.DELETE,
          imageSide: this.docments,
          id: idRef['encryptedValue'],
          name: nameRef['internalValue'],
          type: typeRef['internalValue'],
        }
        this.emitUploadedFile.emit(cascoUploadResponse);
      }

    },
  };

  @Output('emitUploadedFile') emitUploadedFile = new EventEmitter<ClaimsUploadResponse>();

  public constructor(
    //private readonly messagingService: MessagingService,
    public apiService: ApiService
  ) { }

  public ngOnInit() {
  }


  public addErrorMessageIn5Seconds() {
   /* setTimeout(() => {
      this.messagingService.add({
        text: 'Error message',
        type: 'error',
        actionButtonText: 'ok',
      });
    }, 5000);*/
  }

  public updateFlag(flag: string){
    this.apiService.chooseFileSubject.next(flag);
  }

}
